<template>
  <div class="update-dialog-mask" v-if="visible">
    <div class="update-dialog-card">
      <div class="update-dialog-close" @click="hide">
        <span class="vux-close"></span>
      </div>

      <div class="update-card-title">请填写新手机号</div>
      <x-input
        class="update-card-cellphone"
        placeholder="请输入完整手机号码"
        type="tel"
        :max="11"
        is-type="china-mobile"
        v-model="phoneNumber"
      />
      <div class="update-card-actions">
        <x-button type="default" class="update-card-button update-card-button__cancel" @click="hide">
          取消
        </x-button>
        <x-button type="primary" class="update-card-button update-card-button__confirm" :disabled="hasDisable"
                  @click="submit">
          确认
        </x-button>
      </div>
    </div>
  </div>
</template>

<script>
import { XInput, XButton } from '@lx-frontend/cvux'
import util from '../../../common/util'

export default {
  components: { XInput, XButton },
  data() {
    return {
      visible: false,
      phoneNumber: ''
    }
  },
  computed: {
    hasDisable() {
      return !util.regexpMap.regexp_mobile.test(this.phoneNumber)
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
      this.phoneNumber = ''
    },
    submit() {
      !this.hasDisable && this.$emit('callback', { mobile_number: this.phoneNumber })
    },
    // 限制只能输入11位
    handleInput (value) {
      this.$nextTick(() => {
        this.phoneNumber = value.substr(0, 11)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.update-dialog-mask {
  max-width: 375px;
  margin: 0 auto;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);

  .update-dialog-card {
    background: #FAFAFB;
    border-radius: 0.213rem;
    position: absolute;
    left: 55/@w2;
    right: 55/@w2;
    top: 50%;
    transform: translateY(-50%);
    padding: 40/@w2;

    .update-dialog-close {
      position: absolute;
      width: 42/@w2;
      height: 42/@w2;
      top: 24/@w2;
      right: 28/@w2;
      cursor: pointer;

      .vux-close {
        width: 100%;
        height: 100%;

        &::before, &::after {
          background: #989EA9;
        }
      }
    }

    .update-card-title {
      color: #1F2023;
      font-weight: bold;
      font-size: 34/@w2;
      line-height: 48/@w2;
      text-align: center;
    }

    .update-card-cellphone {
      border-radius: 5/@w2;
      margin: 42/@w2 0 52/@w2 0;
      border: 1px solid #d9d9d9;
      font-size: 30/@w2;

      &::before {
        border-top: 0;
      }
    }

    .update-card-actions {
      display: flex;
      flex: 1;
      justify-content: space-between;

      .update-card-button {
        line-height: 88/@w2;
        font-size: 28/@w2;
        font-weight: 400;
        flex: 1;

        &.update-card-button__cancel {
          color: #989EA9;
          border-radius: 3/@w2;
          margin-right: -1px;
        }

        &.update-card-button__confirm {
          color: #fff;
          margin-left: 40/@w2;
          background: #3a5999;

          &[disabled] {
            opacity: 0.4;
          }
        }
      }
    }

  }
}
</style>
